<script setup>

</script>

<template>
  <div
    id="about-card"
    class="relative rounded-xl shadow p-5"
  >
    <div
      class="absolute bg-cover w-full bg-scroll bg h-full top-0 left-0 -z-10 rounded-xl"
      style="
        background-image: url('https://plus.unsplash.com/premium_photo-1675367606982-2a211004b593?q=80&w=923&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3');
        background-position: center;

    "
    />
    <div class="absolute rounded-xl top-0 left-0 w-full h-full div-with-hole -z-10" />
    <div class="flex w-full flex-col items-start md:space-y-5">
      <div class="text-left mt-4 mb-4">
        <span class="text-2xl md:text-5xl text-gray-700 mb-4 font-semibold block">About</span>
        <span class="text-4xl md:text-7xl text-green-500 font-bold block">Ghana Connect</span>
      </div>
      <div class="text-sm md:text-lg text-gray-600 md:w-8/12 text-justify font-medium">
        <p class="mb-2">
          Welcome to “Ghana Connect,” your community-sharing platform for Ghanaians and enthusiasts. We create a vibrant
          space for sharing experiences, accessing valuable information, and building meaningful connections across various sectors.
        </p>
        <p class="mb-2">
          Join “Ghana Connect” today and be part of a growing community celebrating knowledge, culture, and shared
          experiences. Together, we build a network that thrives on collaboration and connection.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.div-with-hole {
  mask: radial-gradient(250px circle at 90% 50%, #0000 30%, #000 100%);
  backdrop-filter: blur(25px);
  background: #fff9;
}
@media screen and (max-width: 768px) {
  .div-with-hole {
    mask: radial-gradient(280px circle at 90% 10%, #0000 0%, #000 100%);
    backdrop-filter: blur(10px);
    background: #fff9;
  }
}
</style>